// src/App.js
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./utils/PrivateRoute";
import AdminRoute from "./utils/AdminRoute";
import Layout from "./components/Layout";
import { ToastContainer } from "react-toastify";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import CreateTicket from "./pages/CreateTicket";
import DraftTicket from "./pages/DraftTicket";
import PendingTicket from "./pages/PendingTicket";
import CompletedTicket from "./pages/CompletedTicket";
import AbandonedTicket from "./pages/AbandonedTicket";
import EditTicket from "./pages/EditTicket";
import Setting from "./pages/Setting";

export default function App() {
    return (
        <Router>
            <div className="App min-h-screen bg-gray-50">
                <Routes>
                    {/* Public routes for unauthenticated users */}
                    <Route path="/" element={<Home />} />

                    {/* Protected routes wrapped with Layout */}
                    <Route
                        element={
                            <PrivateRoute>
                                <Layout /> {/* Wrap protected routes with Layout */}
                            </PrivateRoute>
                        }
                    >
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="create-ticket" element={<CreateTicket />} />
                        <Route path="draft-ticket" element={<DraftTicket />} />
                        <Route path="pending-ticket" element={<PendingTicket />} />
                        <Route path="completed-ticket" element={<CompletedTicket />} />
                        <Route path="abandoned-ticket" element={<AbandonedTicket />} />

                        <Route
                            path="setting"
                            element={
                                <AdminRoute>
                                    <Setting />
                                </AdminRoute>
                            }
                        />

                        {/* Edit existing ticket (from DraftTicket list, etc.) */}
                        <Route path="edit-ticket/:ticketId" element={<EditTicket />} />
                    </Route>
                </Routes>

                <ToastContainer position="top-right" autoClose={4000} />
            </div>
        </Router>
    );
}

/**
 *                             _ooOoo_
 *                            o8888888o
 *                            88" . "88
 *                            (| -_- |)
 *                            O\  =  /O
 *                         ____/`---'\____
 *                       .'  \\|     |//  `.
 *                      /  \\|||  :  |||//  \
 *                     /  _||||| -:- |||||-  \
 *                     |   | \\\  -  /// |   |
 *                     | \_|  ''\---/''  |   |
 *                     \  .-\__  `-`  ___/-. /
 *                   ___`. .'  /--.--\  `. . __
 *                ."" '<  `.___\_<|>_/___.'  >'"".
 *               | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *               \  \ `-.   \_ __\ /__ _/   .-` /  /
 *          ======`-.____`-.___\_____/___.-`____.-'======
 *                             `=---='
 *          ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
 *                     佛祖保佑        永无BUG
 *            佛曰:
 *                   写字楼里写字间，写字间里程序员；
 *                   程序人员写程序，又拿程序换酒钱。
 *                   酒醒只在网上坐，酒醉还来网下眠；
 *                   酒醉酒醒日复日，网上网下年复年。
 *                   但愿老死电脑间，不愿鞠躬老板前；
 *                   奔驰宝马贵者趣，公交自行程序员。
 *                   别人笑我忒疯癫，我笑自己命太贱；
 *                   不见满街漂亮妹，哪个归得程序员？
*/
